import React from 'react';
import { BaasicButton, BaasicConfirmModal, BaasicTable, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { formatDate, isSome } from 'core/utils';
import _ from 'lodash';
import { observer } from 'mobx-react';

const UpdateInventoryLogTemplate = ({
	t,
	updateInventoryLogViewStore,
	updateInventoryLogViewStore: { loading, selectedInventoryForInventoryLog },
}) => {
	if (loading) return <Loader />;
	return isSome(selectedInventoryForInventoryLog) ? (
		<InventoryLogPerWarehouse viewStore={updateInventoryLogViewStore} t={t} />
	) : (
		<InventoryLog viewStore={updateInventoryLogViewStore} t={t} />
	);
};

const InventoryLogPerWarehouse = observer(({ viewStore, t }) => {
	const { product, selectedInventoryForInventoryLog, data, loadOlderLogsCount, loadOlderLogs } = viewStore;
	return (
		<section className="layout__main__body">
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('UPDATEINVENTORYLOG.HISTORY')}</h3>
			</div>
			<div className="ReactModal__body">
				<div className="box--primary box--sml spc--bottom--xsml">
					<div className="row">
						<div className="col col-sml-12 col-med-6 spc--bottom--sml">
							<label className="display--b type--xsml type--uppercase">{t('UPDATEINVENTORYLOG.SKU')}</label>
							<p className="type--sml type--color--dark">{product.mainSku}</p>
						</div>
						<div className="col col-sml-12 col-med-6 spc--bottom--sml">
							<label className="display--b type--xsml type--uppercase">{t('UPDATEINVENTORYLOG.WAREHOUSE')}</label>
							<p className="type--sml type--color--dark">
								{selectedInventoryForInventoryLog.assignedWarehouse.identifier}
							</p>
						</div>
						<div className="col col-sml-12 col-med-6 spc--bottom--sml">
							<label className="display--b type--xsml type--uppercase">{t('UPDATEINVENTORYLOG.LASTUPLOAD')}</label>
							<p className="type--sml type--color--dark">
								{data != null && data[0] != null ? formatDate(data[0].dateUpdated, true, 'LLL') : '-'}
							</p>
						</div>
						<div className="col col-sml-12 col-med-6 spc--bottom--sml">
							<label className="display--b type--sml type--uppercase">{t('UPDATEINVENTORYLOG.ACTUALQTY')}</label>
							<p className="type--sml type--color--dark">{selectedInventoryForInventoryLog.quantity}</p>
						</div>
					</div>
				</div>

				<div className="box--primary box--sml spc--bottom--xsml">
					<table className="table table--secondary">
						<colgroup>
							<col width="200" />
							<col width="150" />
							<col />
						</colgroup>
						<thead>
							<tr>
								<th className="border">{t('UPDATEINVENTORYLOG.DATETIME')}</th>
								<th className="border">{t('UPDATEINVENTORYLOG.CHANNEL')}</th>
								<th className="border type--right">{t('UPDATEINVENTORYLOG.QTY')}</th>
							</tr>
						</thead>

						<tbody>
							{data != null &&
								_.map(data.slice(0, loadOlderLogsCount), item => {
									return (
										<tr key={item.id}>
											<td>
												<label htmlFor={item.id}>
													<span className="type--color--text">{formatDate(item.dateUpdated, true, 'LLL')}</span>
												</label>
											</td>
											<td>
												<label htmlFor={item.id}>
													<span className="type--color--text">{item.channel.name}</span>
												</label>
											</td>
											<td className="type--right">
												<label htmlFor={item.id}>
													<span className="type--color--text">{item.quantity}</span>
												</label>
											</td>
										</tr>
									);
								})}
						</tbody>
					</table>

					{loadOlderLogsCount < 30 && loadOlderLogsCount < data.length && (
						<button className="btn table--secondary--expand" onClick={() => loadOlderLogs()}>
							{t('UPDATEINVENTORYLOG.SHOWOLDER')}
							<i className="icon icon--sml icon--arrow-down"></i>
						</button>
					)}
				</div>
			</div>
		</section>
	);
});

const InventoryLog = observer(({ viewStore, t }) => {
	const {
		product,
		isChannelInventoryLogPage,
		data,
		channel,
		listStore,
		tableData,
		groupable,
		noDataItem,
		expandChange,
		group,
		change,
		openUploadInventoryConfirmModal,
		uploadInventoryConfirmModal,
		isUploadAllowed,
	} = viewStore;
	return (
		<section className="flex--grow--1">
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('UPDATEINVENTORYLOG.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<div className="spc--bottom--xsml">
					<p className="type--med type--wgt--bold">{isChannelInventoryLogPage ? channel.name : product.mainSku}</p>
				</div>
				{data.length != 0 && (
					<div className="flex--grow--1 k-grid--update-inventory">
						<BaasicTable
							{...{
								listStore,
								data,
								tableData: tableData,
								viewStore,
								groupable,
								noDataItem,
								expandChange,
								group,
								change,
							}}
						/>
					</div>
				)}
			</div>

			<div className="ReactModal__footer">
				{isUploadAllowed && (
					<BaasicButton
						className="btn btn--med btn--primary spc--bottom--sml spc--right--sml"
						icon="icon icon--xmed icon--inventory-update spc--right--sml"
						onClick={() => openUploadInventoryConfirmModal()}
						label={t('UPDATEINVENTORYLOG.RUNINVENTORYUPDATE')}
					/>
				)}
			</div>
			<BaasicConfirmModal modalParams={uploadInventoryConfirmModal} />
		</section>
	);
});

export default defaultTemplate(UpdateInventoryLogTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/UpdateInventoryLogTemplate.jsx